import { CSSProperties } from 'react';
import { observer } from 'mobx-react';

import Icon from '@/common/components/Icon/Icon';
import LoadingTask from '@/netbox/entity/LoadingTask';

import styles from '../LoadingTaskList.module.css';

interface LoadingTaskItemProps {
  task: LoadingTask;
}

function LoadingTaskItem(props: LoadingTaskItemProps) {
  const { task } = props;

  return (
    <div className={styles.loadingTask}>
      <div className={styles.loadingTaskHeader}>
        <div className={styles.loadingTaskTitle} aria-label="Loading task title">{task.title}</div>

        <div className={styles.loadingTaskStatus} aria-label="Loading task status">
          {task.isCompleted ? <Icon name="check" /> : <Icon name="swap" className={styles.loadingTaskIconLoading} />}
        </div>
      </div>

      {!task.isCompleted && (
        <div
          className={styles.loadingTaskPercent}
          aria-label="Loading task progress"
          style={{ '--progress': `${task.percentageOfCompletion.toFixed()}%` } as CSSProperties}
        />
      )}
    </div>
  );
}

export default observer(LoadingTaskItem);
